import { render, staticRenderFns } from "./AreasView.vue?vue&type=template&id=13199cc0&scoped=true"
import script from "./AreasView.vue?vue&type=script&lang=js"
export * from "./AreasView.vue?vue&type=script&lang=js"
import style0 from "./AreasView.vue?vue&type=style&index=0&id=13199cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13199cc0",
  null
  
)

export default component.exports